var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocateMyDeviceMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,2C15.1777344,2,8,9.1777344,8,18c0,5.8662109,2.6474609,9.8125,6.3105469,15.2744141l7.8203125,11.7246094 C22.5478516,45.6259766,23.2460938,46,24,46s1.4521484-0.3740234,1.8681641-1l7.8212891-11.7255859 C37.3525391,27.8125,40,23.8662109,40,18C40,9.1777344,32.8222656,2,24,2z M32.0283203,32.1601562L24.203125,43.8916016 c-0.0898438,0.1367188-0.3154297,0.1376953-0.4072266-0.0009766l-7.8242188-11.7304688C12.5048828,26.9921875,10,23.2578125,10,18 c0-7.7197266,6.2802734-14,14-14s14,6.2802734,14,14C38,23.2578125,35.4951172,26.9921875,32.0283203,32.1601562z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,10h-6c-1.1025391,0-2,0.8974609-2,2v13c0,1.1025391,0.8974609,2,2,2h6c1.1025391,0,2-0.8974609,2-2V12 C29,10.8974609,28.1025391,10,27,10z M27,12l0.0013428,9H21v-9H27z M21,25v-2h6.0016479l0.0003052,2H21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateMyDeviceMedium);
export default __webpack_public_path__ + "static/media/locate-my-device--medium.880a8a29c9423e21b983fc02e20b0cd0.svg";
export { ForwardRef as ReactComponent };